import { render, staticRenderFns } from "./checkBoxOn.vue?vue&type=template&id=3d804e4f&"
import script from "./checkBoxOn.vue?vue&type=script&lang=ts&"
export * from "./checkBoxOn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports